import {Box, InputLabel, Stack} from '@mui/material';
import {TextFieldElement, TextFieldElementProps} from 'react-hook-form-mui';
import {useTranslations} from 'next-intl';
import {ReactNode} from 'react';

interface FormInputProps extends TextFieldElementProps {
  suffixLabel?: ReactNode;
}

export const FormInput = ({
  label,
  suffixLabel,
  placeholder,
  disabled,
  InputProps,
  InputLabelProps,
  ...props
}: FormInputProps) => {
  const t = useTranslations();

  return (
    <Stack spacing={1} sx={{opacity: disabled ? 0.7 : 1}}>
      <Box display="flex" justifyContent="space-between">
        <InputLabel
          {...InputLabelProps}
          sx={{
            fontWeight: 500,
            lineHeight: 1,
            textTransform: 'capitalize',
            color: 'inherit',
            ...(InputLabelProps?.sx ?? {}),
          }}
        >
          {typeof label === 'string' ? t(label) : label}
        </InputLabel>
        {suffixLabel && (
          <InputLabel sx={{fontWeight: 500, lineHeight: 1}}>
            {suffixLabel}
          </InputLabel>
        )}
      </Box>
      <TextFieldElement
        disabled={disabled}
        placeholder={placeholder ? t(placeholder) : undefined}
        {...props}
        InputProps={{
          sx: {
            borderRadius: '0.5rem',
            input: {
              padding: 1.7,
              '::placeholder': {
                textTransform: 'capitalize',
              },
            },
          },
          ...InputProps,
        }}
      />
    </Stack>
  );
};
